// Accessibility enhancement for Bazaarvoice star ratings (PLP inline_rating + PDP rating_summary).
// BV renders the stars as aria-hidden SVGs, so this promotes the rating to a single role="img"
// node with a "X out of 5 stars" label and hides its subtree so it announces consistently on hover.
// Re-applied on mutations because BV re-renders the widget after first paint.
(function () {
  'use strict';

  var SELECTOR = '.site-rating[data-bv-show="inline_rating"], .site-rating[data-bv-show="rating_summary"]';

  // Pull the numeric rating out of BV's phrasing, e.g. "4.7 out of 5 stars" or "...is 4.6 of 5.".
  function getRatingValue(rawLabel) {
    var match = rawLabel.match(/([0-9]+(?:\.[0-9]+)?)\s*(?:out of|of)\s*5/i);
    return match ? match[1] : null;
  }

  // Element to decorate. On the PDP, promote the whole "view all reviews" wrapper so the
  // rating, its "Read all reviews" text and the padding read as one object; PLP has no wrapper.
  function getTarget(rating) {
    if (rating.getAttribute('data-bv-show') === 'rating_summary') {
      return rating.closest('.product-main__reviews-view-all') || rating;
    }
    return rating;
  }

  // Build the announced label. Keep the PLP label as-is; reword the PDP summary to match
  // ("X out of 5 stars") and append the visible "Read all reviews" text.
  function computeLabel(rating, target, rawLabel) {
    if (rating.getAttribute('data-bv-show') !== 'rating_summary') {
      return rawLabel;
    }
    var value = getRatingValue(rawLabel);
    var label = value ? value + ' out of 5 stars' : rawLabel;
    var extra = target.querySelector('.bv-inline-ratings__text');
    if (extra && extra.textContent.trim()) {
      label += '. ' + extra.textContent.trim();
    }
    return label;
  }

  function enhance(rating) {
    // BV exposes the readable rating on an inner element once ready.
    var labelled = rating.querySelector('[aria-label]');
    var rawLabel = labelled ? (labelled.getAttribute('aria-label') || '').trim() : '';
    if (!rawLabel) {
      return; // Widget not rendered yet; a later mutation will retry.
    }

    var target = getTarget(rating);
    target.setAttribute('role', 'img');
    target.setAttribute('aria-label', computeLabel(rating, target, rawLabel));

    // role="img" must be a single leaf: hide the inner subtree (re-applied for BV re-renders).
    var children = target.children;
    for (var c = 0; c < children.length; c++) {
      children[c].setAttribute('aria-hidden', 'true');
    }

    // role="img" must be a leaf: strip href from inner links since tabindex="-1" alone doesn't stop AT focusing an aria-hidden control.
    var links = target.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      links[i].removeAttribute('href');
      links[i].removeAttribute('tabindex');
    }
    var focusables = target.querySelectorAll('button, [tabindex]');
    for (var j = 0; j < focusables.length; j++) {
      focusables[j].setAttribute('tabindex', '-1');
    }
  }

  function scan() {
    var nodes = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      enhance(nodes[i]);
    }
  }

  var scheduled = false;
  function scheduleScan() {
    if (scheduled) {
      return;
    }
    scheduled = true;
    window.setTimeout(function () {
      scheduled = false;
      scan();
    }, 100);
  }

  function init() {
    scan();

    // BV injects ratings asynchronously and grids re-render on pagination/filtering.
    var observer = new MutationObserver(scheduleScan);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-bv-ready']
    });
  }

  // Script is deferred, so the DOM is already parsed when this runs.
  init();
})();
